var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Editor',{attrs:{"height":100},model:{value:(_vm.itemObj.message_entity.content),callback:function ($$v) {_vm.$set(_vm.itemObj.message_entity, "content", $$v)},expression:"itemObj.message_entity.content"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }